export type ReminderResult = {
  delivery_email?: string;
  email: string;
  sent: boolean | null;
  message: string;
};
export const retryableEmails = (results: ReminderResult[]) =>
  results
    .filter((result) => result.sent === false)
    .map((result) => result.email);
export const selectionOnPage = (selected: number[], ids: number[]) =>
  selected.filter((id) => ids.includes(id));
export const csvCell = (value: unknown) => {
  let text = value == null ? "" : String(value);
  if (/^[=+@\-\t\r]/.test(text)) text = "'" + text;
  return '"' + text.replaceAll('"', '""') + '"';
};
